import { MODAL_WINDOW } from 'ACTIONS';

export const showModal = (id, isOpened, modalType = 'active_modal', closeClicked) => dispatch => dispatch({
    type: MODAL_WINDOW,
    id,
    modalType,
    closeClicked,
    isOpened
});
